/**
 * Croatian kuna.
 */
export var HRK = {
  code: 'HRK',
  base: 10,
  exponent: 2
};